import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import { mobileNumberFormat } from "../employee/generalInfoValidation";

export const DECEASED = FORM_FIELDS.DECEASED;
export const BASIC_INFO = DECEASED.BASIC_INFO;
export const SUPPORTING_DOCUMENT = DECEASED.SUPPORTING_DOCUMENT;
export const MODAL = DECEASED.MODAL;

export const deceasedFormValidation = yup.object().shape({
  [BASIC_INFO.DEATH_DATE]: yup.string().required("death date is required"),
  [BASIC_INFO.EMERGENCY_CONTACT]: yup
    .string()
    .matches(mobileNumberFormat, "Mobile Number is not valid")
    .required("emergency contact is required"),
});

export type DeceasedFormDataType = yup.InferType<typeof deceasedFormValidation>;
